import { routesUrl } from 'app/fuse-configs/navigationConfig';

export type BoosterOption = 'game' | 'prono' | 'referral';

type BoosterOptionConfig = {
  option: BoosterOption;
  navItemId: string;
  pathPrefix: string;
  textKey: string;
};

export const BOOSTER_OPTIONS: BoosterOptionConfig[] = [
  { option: 'game', navItemId: 'games', pathPrefix: routesUrl.gamesRoot, textKey: 'navigation.boosterNewPlayers.game' },
  {
    option: 'prono',
    navItemId: 'prono',
    pathPrefix: routesUrl.pronoRoot,
    textKey: 'navigation.boosterNewPlayers.prono',
  },
  {
    option: 'referral',
    navItemId: 'referral',
    pathPrefix: routesUrl.referral,
    textKey: 'navigation.boosterNewPlayers.referral',
  },
];

const MAX_ICON_COUNT = 99;

export const getOptionForPath = (pathname: string): BoosterOption | null => {
  const match = BOOSTER_OPTIONS.find(
    ({ pathPrefix }) => pathname === pathPrefix || pathname.startsWith(`${pathPrefix}/`),
  );
  return match ? match.option : null;
};

export const formatIconCount = (count: number): string =>
  count > MAX_ICON_COUNT ? `${MAX_ICON_COUNT}+` : String(count);
